import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import DashboardLayout from "./DashboardLayout";
import type { UserProfile } from "./Sidebar";

interface AuthGuardProps {
  children: ReactNode;
  user: UserProfile | null;
  title?: string;
  subtitle?: string;
  actions?: ReactNode;
}

export default function AuthGuard({ children, user, title, subtitle, actions }: AuthGuardProps) {
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <DashboardLayout user={user} title={title} subtitle={subtitle} actions={actions}>
      {children}
    </DashboardLayout>
  );
}